import axios from 'axios';
import { getAuthHeaders, clearAuthSession, canAttemptSilentReauth, attemptSilentFacetReauth } from '../services/auth';

const apiClient = axios.create({
  baseURL: '/api/v1',
  headers: { 'Content-Type': 'application/json' },
});

// Request interceptor: inject auth headers from session storage
apiClient.interceptors.request.use((config) => {
  const authHeaders = getAuthHeaders();
  Object.entries(authHeaders).forEach(([key, value]) => {
    config.headers[key] = value;
  });
  return config;
});

// Response interceptor: handle 401 globally
// Facet 模式下本地会话 JWT（24h）过期会先尝试透明重登（SSO 会话通常仍在），
// 重登回来仍 401（标记已置位）或本地模式才清会话跳登录页。
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      const onAuthPage = path === '/login' || path.startsWith('/auth/callback');
      if (!onAuthPage && canAttemptSilentReauth()) {
        void attemptSilentFacetReauth().then((ok) => {
          if (!ok) {
            clearAuthSession();
            window.location.href = '/login';
          }
        });
      } else if (!onAuthPage) {
        clearAuthSession();
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
